import { render, staticRenderFns } from "./CreatDsGroup.vue?vue&type=template&id=189dbcb0"
import script from "./CreatDsGroup.vue?vue&type=script&lang=js"
export * from "./CreatDsGroup.vue?vue&type=script&lang=js"
import style0 from "./CreatDsGroup.vue?vue&type=style&index=0&id=189dbcb0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189dbcb0')) {
      api.createRecord('189dbcb0', component.options)
    } else {
      api.reload('189dbcb0', component.options)
    }
    module.hot.accept("./CreatDsGroup.vue?vue&type=template&id=189dbcb0", function () {
      api.rerender('189dbcb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/group/CreatDsGroup.vue"
export default component.exports